import { React } from "react";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import MyQuotientChart from "../components/MyQuotientChart";

import useStyles from './MyQuotient.style';

const MyGoalResultText = props => {
	const { color, title, subtitle } = props
	return (
		<>
			<Typography variant="h5" style={{ color: color }}>{title}</Typography>
			<Typography>{subtitle}</Typography>
		</>
	)
}

const MyQuotient = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.root}>
            <Typography variant="h3" className={classes.title}>My Goals</Typography>
            <div className={classes.infoText}>
					{props.currentChildrenQty === props.desiredChildrenQty &&
						<MyGoalResultText color="gold" title="You’re on the Goal Line" subtitle="Congratulations, You have reached your goal!" />
					}
					{props.currentChildrenQty < props.desiredChildrenQty &&
						<MyGoalResultText color="MediumAquaMarine" title="You’re in the Green Zone" subtitle="You have not reached your goal yet" />
					}
					{props.currentChildrenQty > props.desiredChildrenQty &&
						<MyGoalResultText color="purple" title="You’re in the Purple Zone" subtitle="You have passed your goal" />
					}
				</div>
            <Box className={classes.chart}>
                <MyQuotientChart
                    currentChildren={props.currentChildrenQty}
                    desiredChildren={props.desiredChildrenQty}
                />
            </Box>
        </Box>
    );
};

export default MyQuotient;
